import { Component, OnInit } from '@angular/core';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { PrepaidInvoiceService } from 'src/app/services/prepaid-invoice.service';
import { DownloadService } from 'src/app/services/download.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-prepaid-invoices',
  templateUrl: './prepaid-invoices.component.html',
  styleUrls: ['./prepaid-invoices.component.scss']
})
export class PrepaidInvoicesComponent implements OnInit {
  prepaids = [];
  data: any;
  isLoading = true;
  onlyWithoutInvoice = true;
  uploadingPrepaidId: number = null;
  deletingPrepaidId: number = null;

  constructor(
    private prepaidInvoiceService: PrepaidInvoiceService,
    private downloadService: DownloadService,
    private alertService: HttpAlertService
  ) {}

  ngOnInit(): void {
    this.fetchPrepaids(1);
  }

  onFilterChange(): void {
    this.fetchPrepaids(1);
  }

  onPaginate(event): void {
    this.fetchPrepaids(event.page + 1);
  }

  openFilePicker(input: HTMLInputElement): void {
    input.value = '';
    input.click();
  }

  onFileChange(event, prepaid): void {
    const file: File = event?.target?.files?.[0];
    if (!file) {
      return;
    }

    if (file.type !== 'application/pdf') {
      this.alertService.error('Można dodać wyłącznie fakturę w formacie PDF.');
      return;
    }

    this.uploadingPrepaidId = prepaid.id;
    this.readFileAsDataUrl(file).then((content: string) => {
      this.prepaidInvoiceService.upload({
        prepaid_id: prepaid.id,
        invoice_name: file.name,
        invoice_mime_type: file.type,
        invoice_content: content,
      }).subscribe((response: any) => {
        prepaid.manual_invoice = response.data.manual_invoice;
        this.uploadingPrepaidId = null;
        this.alertService.success('Dodano fakturę. Jest już dostępna dla klienta.');
        if (this.onlyWithoutInvoice) {
          this.prepaids = this.prepaids.filter((item) => item.id !== prepaid.id);
        }
      }, () => {
        this.uploadingPrepaidId = null;
        this.alertService.error('Nie udało się dodać faktury.');
      });
    }).catch(() => {
      this.uploadingPrepaidId = null;
      this.alertService.error('Nie udało się odczytać pliku faktury.');
    });
  }

  downloadInvoice(prepaid): void {
    if (!prepaid.manual_invoice) {
      return;
    }

    this.downloadService.downloadPrepaidManualInvoiceAdmin(prepaid.manual_invoice).subscribe((data) => {
      saveAs(data, prepaid.manual_invoice.original_name);
    });
  }

  deleteInvoice(prepaid): void {
    if (!prepaid.manual_invoice || !window.confirm('Usunąć dodaną fakturę?')) {
      return;
    }

    this.deletingPrepaidId = prepaid.id;
    this.prepaidInvoiceService.delete(prepaid.id).subscribe(() => {
      prepaid.manual_invoice = null;
      this.deletingPrepaidId = null;
      this.alertService.success('Usunięto fakturę.');
      if (this.onlyWithoutInvoice) {
        this.fetchPrepaids(this.data?.current_page || 1);
      }
    }, () => {
      this.deletingPrepaidId = null;
      this.alertService.error('Nie udało się usunąć faktury.');
    });
  }

  private fetchPrepaids(page: number): void {
    this.isLoading = true;
    this.prepaidInvoiceService.listForAdmin(page, this.onlyWithoutInvoice).subscribe((response: any) => {
      this.data = response.data;
      this.prepaids = response.data.data;
      this.isLoading = false;
    }, () => {
      this.isLoading = false;
    });
  }

  private readFileAsDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }
}
